var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._g(_vm._b({attrs:{"persistent":"","overlay-color":"#0D0C0CB2","overlay-opacity":"1"}},'v-dialog',{ ..._vm.$attrs },false),_vm.$listeners),[_c('div',{staticClass:"dialog_box",style:({'padding':_vm.isPadding ? '32px 16px 8px 16px' : ''})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }